module.exports = __webpack_public_path__ + "assets/img/reservation.1fe2d464.png";